import { Descriptions } from "antd";
import { useMemo } from "react";
import { wrapUpDescriptions } from "@/utils/info";
import { ModalProp } from "@/types";

type SharedBasicProps = {
  rawData: Record<string, unknown>;
  dataProps: ModalProp[];
  className?: string;
  column?: number;
  labelStyle?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
};

export default function RawSharedBasic(props: SharedBasicProps) {
  const { rawData, dataProps, className, column = 2, labelStyle, contentStyle } = props;
  const keyValues = useMemo(() => {
    const items = wrapUpDescriptions(dataProps, rawData as Record<string, any>);
    return items.map((item) => ({
      ...item,
      span: 1,
    }));
  }, [rawData, dataProps]);

  const styles = useMemo(
    () => ({ label: labelStyle, content: contentStyle }),
    [labelStyle, contentStyle],
  );
  return (
    <Descriptions
      column={column}
      size="small"
      className={className}
      bordered
      items={keyValues}
      styles={styles}
    />
  );
}
